/**
 * @author: Ujjwal Jain
 * @file: userTestPrototype.js
 *
 * @copyright: KNOLSKAPE Solutions Pvt Ltd
 **/

import Immutable from 'immutable';
import actionConsts from 'constants/actions';

const initialState = Immutable.fromJS({
    isIntroPageSeen: false,
    showIntroPage: false,
    activeIdeaId: -1,
    isPhaseAvailableToUser: false,
    suggestions: []
});


const userTestPrototype = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.get('SET_USER_TEST_PROTOTYPE_PHASE_STATE'):
            return state.mergeDeep(Immutable.fromJS(action.payload));
        case actionConsts.get('POPULATE_TEST_PROTOTYPE_SUGGESTIONS'):
            return state.set('suggestions', action.payload);
        case 'MAKE_TEST_PROTOTYPE_PHASE_AVAILABLE':
            return state.set('isPhaseAvailableToUser', true);
        default:
            return state;
    }
};

export default userTestPrototype;